import React, { useRef } from "react";
import "../../../Css/TicketDetails.css";
import { useEffect, useState, useCallback } from "react";
import print from "../../../Resources/Images/print.svg";
import Message from "./Messages";
import TransferTicket from "./TransferTicket";
import NewTicket from "./NewTicket";
import TicketDetailsHeader from "./TicketDetailsHeader";
//js
import { CallService, modalAlert, signOut } from "../../../Js/Script";
import { UseTicket, SetTicket } from "../../../Js/Context/TicketCntx";
import { useReactToPrint } from "react-to-print";
export default function TicketDetails() {
  const ticket = UseTicket();
  const setTicket = SetTicket();
  const inputRefs = {
    ticketAnswer: useRef(null),
  };
  const [states, setStates] = useState({
    MessagesData: {},
    ShowTransferTicketComponent: false,
    ShowNewResponseTicketComponent: false,
    ClientInfo: "",
  });
  var clientInfo;
  var fileArr = [];
  useEffect(() => {
    if (ticket && ticket.ticketId) {
      CallService(`TicketContent/${ticket.ticketId}`, null, "GET", false, false)
        .then((res) => {
          setTicket((prevState) => ({
            ...prevState,
            MessagesData: res.result.reverse(),
          }));
        })
        .catch((err) => {
          modalAlert(err.message, "خطا");
        });
    }
    // if (
    //   ticket &&
    //   ticket.targetUser &&
    //   ticket.targetUser.referenceType === true
    // ) {
    //   setStates((prevState) => ({
    //     ...prevState,
    //     ClientInfo: ticket.targetUser,
    //   }));
    // } else if (
    //   ticket &&
    //   ticket.writerUser &&
    //   ticket.writerUser.referenceType === true
    // ) {
    //   setStates((prevState) => ({
    //     ...prevState,
    //     ClientInfo: ticket.writerUser,
    //   }));
    // }
  }, []);
  //ticket && ticket.ticketId

  //const setShowTransferTicketComponent = useCallback((show) => {
  //    setStates((prevState) => ({
  //        ...prevState,
  //        ShowTransferTicketComponent: show,
  //    }));
  //}, []);
  //const setShowNewResponseTicketComponent = useCallback((show) => {
  //    setStates((prevState) => ({
  //        ...prevState,
  //        ShowNewResponseTicketComponent: show,
  //    }));
  //}, []);

  function StarRating({ starCount }) {
    const stars = Array.from({ length: starCount }, (_, index) => index + 1);
    return (
      <div className="flexRow" id="starRating">
        (
        {stars.map((star) => (
          <div key={star}>&#9733;</div>
        ))}
        )
      </div>
    );
  }
  const onPrint = useReactToPrint({
    content: () => inputRefs.ticketAnswer.current,
  });
  return (
    <div>
      <TicketDetailsHeader
        writerUser={ticket.WriterUserInfo}
        targetUser={ticket.TargetUserInfo}
        ticketId={ticket.ticketId}
      />
      {/* {states.ticketstatus === "بسته" && (
                <div id="satisfactionsurvey"
                    className={`flexrow ${states.showtransferticketcomponent
                            ? "ticketdetails-header-hide"
                            : ""
                        }`}
                >
                    <p
                        className={`flexrow ${states.showtransferticketcomponent
                                ? "none"
                                : ""
                            }`}
                    >میزان رضایت : <strong>{states.satisfactionsurveytxt}</strong></p>
                    <div
                        style={{
                            display: "flex",
                            alignitems: "center",
                            height: "100px",
                        }}
                        className={`flexrow ${states.showtransferticketcomponent
                                ? "none"
                                : ""
                            }`}
                    >
                        <p
                            className="emoji"
                            onclick={() => {
                                submitsatisfactionsurvey(1);
                            }}
                        >
                            &#128578;
                        </p>
                        <p
                            className="emoji"
                            onclick={() => {
                                submitsatisfactionsurvey(2);
                            }}
                        >
                            &#128528;
                        </p>
                        <p
                            className="emoji"
                            onclick={() => {
                                submitsatisfactionsurvey(3);
                            }}
                        >
                            &#128577;
                        </p>
                    </div>
                </div>
            )} */}

      <div className="panel" ref={inputRefs.ticketAnswer}>
        <div className="panel-heading flexRow justify-between">
          <p>
            تیکت {ticket && ticket.ticketId ? ticket.ticketId : ""} |{" "}
            {ticket && ticket.dataTitle ? ticket.dataTitle : ""}
          </p>
          <button
            id="ticketDetails-panel-heading-items"
            className="primary"
            onClick={onPrint}
          >
            <img src={print}></img>
          </button>
        </div>
        {ticket ? (
          <Message
            messagesData={ticket.MessagesData}
            writerUser={ticket.WriterUserInfo}
            targetUser={ticket.TargetUserInfo}
            title={ticket.dataTitle}
            status={ticket.ticket}
          />
        ) : (
          ""
        )}
        <div className="flexRow" style={{ alignItems: "flex-start" }}>
          {ticket && ticket.organizationInfo && (
            <div id="dvOrganizationInfo" className="panel">
              <div className="panel-heading flexColumn">اطلاعات سازمان</div>
              <div style={{ padding: "18px" }}>
                <div style={{ display: "flex" }}>
                  <p>{ticket.organizationInfo.title}</p>
                  <StarRating starCount={ticket.organizationInfo.star} />
                </div>
                <p>{ticket.organizationInfo.address}</p>
                <p>{ticket.organizationInfo.phone}</p>
                <p>{ticket.organizationInfo.website}</p>
              </div>
            </div>
          )}
          {states.ClientInfo && (
            <div id="dvClientInfo" className="panel">
              <div className="panel-heading flexColumn">اطلاعات مشتری</div>
              <div style={{ padding: "18px" }}>
                <div style={{ display: "flex" }}>
                  <p>
                    {states.ClientInfo.firstName +
                      " " +
                      states.ClientInfo.lastName}
                  </p>
                  <StarRating starCount={states.ClientInfo.star} />
                </div>
                <p>{states.ClientInfo.mobileNo}</p>
                <p>{states.ClientInfo.email}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
